<template>
  <div class="flex flex-col items-center px-4 pt-2 pb-8 h-full justify-between">
    <div class="flex flex-col items-center h-fit">
      <div
        class="relative flex flex-col justify-center items-center bg-NAVY-BLUE py-11 px-10 rounded-xl h-full"
      >
        <font-awesome-icon class="w-10 h-10" :icon="itemInfo.icon" />
      </div>
      <div class="flex flex-col">
        <p class="text-lg font-semibold pt-6">{{ itemInfo.title }}</p>
        <p class="text-sm font-normal pt-3">
          {{ itemInfo.content }}
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-6 pt-3 items-center w-full pb-3">
      <div class="flex flex-row items-center gap-1">
        <img class="w-5" src="@/assets/icons/token-2.svg" />
        <p class="font-semibold">+ {{ itemInfo.amount }}</p>
      </div>
      <pow-button
        @click="$emit('start')"
        v-if="itemInfo.state == 'start'"
        secondary
        class="w-full"
        :loading="loading"
      >
        <p>Start Challange</p>
      </pow-button>
      <pow-button
        @click="$emit('collect')"
        v-if="itemInfo.state == 'collect'"
        secondary
        class="w-full"
        :loading="loading"
      >
        <p>Claim Reward</p>
      </pow-button>
      <pow-button
        @click="$emit('claimed')"
        v-if="itemInfo.state == 'claimed'"
        secondary
        class="w-full opacity-50"
        :loading="loading"
      >
        <p>Reward Claimed</p>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import PowButton from '@/components/PowButton.vue'
import { ref } from 'vue'

const props = defineProps({
  itemInfo: {
    type: Object,
    required: true
  }
})
const loading = ref(false)
</script>
